$(window).on('load', function() {
  $('.loader').addClass('hidden');
});

document.addEventListener( 'DOMContentLoaded', function () {
  if( $('.cart-item').length > 0 )$('.cart__footer-items-wrapper,.cart__footer-wrapper').wrapAll('<div class="cartMainWrapper"></div>');
}, false );

(function() {
  var featuredinfoslider = function() {
      $('.featured-info-slider-mobile').flickity({
        // options
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        prevNextButtons: false, 
      });
    };
    var featuredReviewsSlider = function() {
      $('.reviewSlider').flickity({
        // options
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        prevNextButtons: false,  
        groupCells: true 
      });
    };
  var feedSlider = function() {
    $('.instafeed__box').flickity({
      // options
      cellAlign: 'left',
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,  
      groupCells: true 
    });
  };
  var countAnimat = function(){
    const counters = document.querySelectorAll('.count-value');
    const speed = 200;
    
    counters.forEach(counter => {
        const animate = () => {
            const value = +counter.getAttribute('data-val');
            let data = +counter.innerText;
            console.log(value);
            const time = value / speed;
            if (data < value) {
                data = Math.ceil(data + time);
                counter.innerText = data > value ? value : data;
                setTimeout(animate, 50); // Adjust the delay for smoother animation
            } else {
                counter.innerText = value;
            }
        }
        animate();
    });
  }
  var pointSlider = function() {
    if (screen.width < 750) {
       $('.pointeBlocks__box').flickity({
          // options
          cellAlign: 'left',
          wrapAround: true,
          pageDots: true,
          prevNextButtons: false,  
          groupCells: true 
        });
    }
    else {
       $('.pointeBlocks__box').flickity('destroy');
    }
    
  };
  var megaProductSlider = function(){
      // $('.mega-product-list-slider .product-grid').flickity({
      //   // options
      //   cellAlign: 'left',
      //   wrapAround: true,
      //   pageDots: true,
      //   prevNextButtons: false,  
      //   groupCells: true 
      // });
 
  }
  var stickyAddtoCart = function(){
     
    var addToCartButton = document.querySelector('.product-form__submit');
    var price = document.querySelector('.price.price--large');
    var stickyButton = document.createElement('div');
    stickyButton.className = 'sticky-add-to-cart';

    if( $('.addToCartButton').length > 0 ){
      // Combine the HTML content of each variable into the stickyButton
      stickyButton.innerHTML = `
        <div class="sticky-content"> 
          <div class="sticky-price">${price.innerHTML}</div>
          ${addToCartButton.outerHTML}
        </div>
        <div class="stick-bar"><span></span></div>
      `;
      
      document.body.appendChild(stickyButton);
      
      window.addEventListener('scroll', function () {
        var addToCartButtonRect = addToCartButton.getBoundingClientRect();
        var showStickyButton = addToCartButtonRect.top <= 0;
      
        if (showStickyButton) {
          stickyButton.style.display = 'block';
        } else {
          stickyButton.style.display = 'none';
        }
      });
  
      $(document).on('click','.sticky-content .product-form__submit',  function(e){
        $('.product-form__buttons .product-form__submit').trigger('click');
      })
    }
  };
  var compSlider = function() {
    $('.comp-slider-init,.comp-popup__slider').flickity({
      // options
      cellAlign: 'left',
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,  
      groupCells: true,
      imagesLoaded: true
    });
  };
  // var productQtyUpdate = function() {
  //   $(document).on('click','.qtyUpdate',function(e){
  //     e.preventDefault();
  //     var $qtyButton = $(e.currentTarget);
  //     var parent = $(this).parent();
  //     var curval = parseInt(parent.find('input').val());
  //     if( $qtyButton.hasClass('qtyplus')){
  //       curval = curval + 1;
  //       parent.find('input').val(curval);
  //     }
  //     else if($qtyButton.hasClass('qtyminus')) {
  //       if( curval > 1 ){
  //         curval = curval - 1;
  //         parent.find('input').val(curval);
  //       }
  //     }
  //   });
  // };

  // document.querySelectorAll('.addons_list_item').forEach(item => {

  //   const input = item.querySelector('input[type="number"]');
  //   const plusBtn = item.querySelector('.qtyplus');
  //   const minusBtn = item.querySelector('.qtyminus');
  //   const toggleBtn = item.querySelector('.cart-toggle-btn');
  //   const variantId = parseInt(toggleBtn.dataset.variantId);

  //   toggleBtn.textContent = 'Add';

  //   // PLUS (only input change)
  //   plusBtn.addEventListener('click', () => {
  //     let qty = parseInt(input.value) || 0;
  //     input.value = qty + 1;
  //   });

  //   // MINUS (only input change)
  //   minusBtn.addEventListener('click', () => {
  //     let qty = parseInt(input.value) || 0;
  //     if (qty > 0) input.value = qty - 1;
  //   });

  //   // TOGGLE BUTTON
  //   toggleBtn.addEventListener('click', async () => {

  //     let qty = parseInt(input.value) || 0;

  //     // ADD
  //     if (toggleBtn.textContent === 'Add') {

  //       if (qty === 0) return;

  //       await fetch('/cart/add.js', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({
  //           id: variantId,
  //           quantity: qty,
  //           properties: { addon: "true" }
  //         })
  //       });

  //       toggleBtn.textContent = 'Remove';
  //     }

  //     // REMOVE
  //     else {

  //       const cart = await fetch('/cart.js').then(res => res.json());

  //       const itemInCart = cart.items.find(
  //         product => product.variant_id === variantId
  //       );

  //       if (!itemInCart) return;

  //       await fetch('/cart/change.js', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({
  //           id: itemInCart.key,
  //           quantity: 0
  //         })
  //       });

  //       input.value = 1;
  //       toggleBtn.textContent = 'Add';
  //     }

  //   });

  // });

    (() => {
    const root = window.Shopify?.routes?.root || '/';

    const getCart = async () => {
      const response = await fetch(root + 'cart.js');

      if (!response.ok) {
        throw new Error('Unable to load cart.');
      }

      return response.json();
    };

    const cartRequest = async (endpoint, data) => {
      const response = await fetch(root + endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Cart update failed.'
        );
      }

      return result;
    };

    // Match only manually added accessories.
    const isManualAddon = (item, variantId) => {
      return Number(item.variant_id) === variantId &&
        String(item.properties?.addon) === 'true';
    };

    const addonCards = document.querySelectorAll(
      '.addons_list_item'
    );

    // Synchronize button labels with actual cart contents.
    async function syncButtons() {
      const cart = await getCart();

      addonCards.forEach(card => {
        const button = card.querySelector('.cart-toggle-btn');
        if (!button) return;

        const variantId = Number(button.dataset.variantId);

        const manualItems = cart.items.filter(item =>
          isManualAddon(item, variantId)
        );

        const added = manualItems.length > 0;

        button.dataset.added = added ? 'true' : 'false';
        button.textContent = added ? 'Remove' : 'Add';
      });
    }

    addonCards.forEach(card => {
      const input = card.querySelector('.qb-value');
      const plusBtn = card.querySelector('.qtyplus');
      const minusBtn = card.querySelector('.qtyminus');
      const button = card.querySelector('.cart-toggle-btn');

      if (!input || !plusBtn || !minusBtn || !button) {
        return;
      }

      const variantId = Number(button.dataset.variantId);

      if (!variantId) return;

      // Quantity increase
      plusBtn.addEventListener('click', () => {
        const qty = parseInt(input.value, 10) || 1;
        input.value = qty + 1;
      });

      // Minimum quantity is 1
      minusBtn.addEventListener('click', () => {
        const qty = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, qty - 1);
      });

      button.addEventListener('click', async () => {
        if (button.disabled) return;

        button.disabled = true;

        try {
          // Always check current cart, not button text.
          const cart = await getCart();

          const manualItems = cart.items.filter(item =>
            isManualAddon(item, variantId)
          );

          if (manualItems.length > 0) {

            // REMOVE: Only remove manually added items.
            // Re-fetch keys because discounts can change them.
            for (let i = 0; i < 50; i++) {
              const currentCart = await getCart();

              const manualItem = currentCart.items.find(item =>
                isManualAddon(item, variantId)
              );

              if (!manualItem) break;

              await cartRequest('cart/change.js', {
                id: manualItem.key,
                quantity: 0
              });
            }

            const remaining = (await getCart()).items.some(
              item => isManualAddon(item, variantId)
            );

            if (remaining) {
              throw new Error(
                'Some accessory items could not be removed.'
              );
            }

            input.value = 1;

          } else {

            // ADD: Customer may add multiple covers.
            const quantity = Math.max(
              1,
              parseInt(input.value, 10) || 1
            );

            await cartRequest('cart/add.js', {
              items: [{
                id: variantId,
                quantity: quantity,
                properties: {
                  addon: 'true'
                }
              }]
            });
          }

          await syncButtons();

        } catch (error) {
          console.error('Accessory error:', error);
          alert(error.message || 'Something went wrong.');

          try {
            await syncButtons();
          } catch (syncError) {
            console.error(syncError);
          }

        } finally {
          button.disabled = false;
        }
      });
    });

    syncButtons().catch(console.error);

  })();


  featuredinfoslider();
  featuredReviewsSlider();
  feedSlider();
  countAnimat();
  pointSlider();
  megaProductSlider();
  stickyAddtoCart();
  compSlider();
  productQtyUpdate();
   $(document).on('shopify:section:load', function(event) { 
    featuredinfoslider();
     featuredReviewsSlider();
     feedSlider();
     countAnimat();
     pointSlider();
     megaProductSlider();
     stickyAddtoCart();
     compSlider();
     productQtyUpdate();
  });
  window.addEventListener('resize', pointSlider);
}());